var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.normalized.length
        ? _c(
            "div",
            { staticClass: "transcript-participants__card rounded-sm pa-4" },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex align-center justify-space-between mb-4"
                },
                [
                  _c("span", { staticClass: "table-new-ux-v1-title" }, [
                    _vm._v(_vm._s(_vm.countLabel))
                  ]),
                  _vm.editable
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: { icon: "", "x-small": "" },
                                            on: { click: _vm.abrirEdicao }
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("icon-svg", {
                                          attrs: {
                                            name: "edit",
                                            size: "16",
                                            color: "var(--muted)"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2316061289
                          )
                        },
                        [_c("span", [_vm._v("Editar participantes")])]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "d-flex flex-column az-gap-small" },
                [
                  _vm._l(_vm.normalized, function(p, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "transcript-participants__item" },
                      [
                        _c(
                          "v-avatar",
                          {
                            staticClass:
                              "transcript-participants__avatar mr-3 text-color-100",
                            attrs: { size: "32" }
                          },
                          [_vm._v(" " + _vm._s(_vm.getInitials(p.name)) + " ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-column flex-grow-1",
                            staticStyle: { "min-width": "0" }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "az-text-primary az-size-14 font-semibold text-truncate"
                              },
                              [_vm._v(" " + _vm._s(p.name) + " ")]
                            ),
                            _c(
                              "span",
                              { staticClass: "az-text-small text-truncate" },
                              [_vm._v(_vm._s(p.email || "-"))]
                            )
                          ]
                        ),
                        _vm.editable
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "ml-2 flex-shrink-0",
                                                  attrs: {
                                                    icon: "",
                                                    small: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.$emit(
                                                        "remove",
                                                        {
                                                          index: i,
                                                          participant: p
                                                        }
                                                      )
                                                    }
                                                  }
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c("icon-svg", {
                                                attrs: {
                                                  name: "trash",
                                                  size: "16",
                                                  color: "var(--muted)"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [_c("span", [_vm._v("Remover")])]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  _vm.editable
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "transcript-participants__add az-text-small",
                          on: {
                            click: function($event) {
                              return _vm.$emit("add")
                            }
                          }
                        },
                        [_vm._v(" + Adicionar participante ")]
                      )
                    : _vm._e()
                ],
                2
              )
            ]
          )
        : _c("TranscriptStateFeedback", {
            attrs: {
              state: "empty",
              icon: "mdi-account-group-outline",
              message: "Nenhum participante registrado para esta reunião."
            },
            scopedSlots: _vm._u(
              [
                _vm.editable
                  ? {
                      key: "button",
                      fn: function() {
                        return [
                          _c(
                            "BaseButton",
                            {
                              attrs: { sm: "", fitContent: "", primary: "" },
                              on: { click: _vm.abrirEdicao }
                            },
                            [_vm._v(" Adicionar participante ")]
                          )
                        ]
                      },
                      proxy: true
                    }
                  : null
              ],
              null,
              true
            )
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }